export default "__VITE_ASSET__ClnwdIlS__"